import LayoutPage from "../../Components/LayoutPage";
import Buttons from "./Components/Buttons";
import ChallengeInfoContainer from "./Components/ChallengeInfoContainer";
import PhaseInfoContainer from "./Components/PhaseInfoContainer";
import { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/api";
import { AsyncContent } from "../../Components/AsyncState";
import Pagination, { buildPaginatedUrl, paginationFromResponse } from "../../Components/Pagination/Pagination";

export default function ChallengeInfo() {
  const [challenge, setChallenge] = useState(null);
  const [phases, setPhases] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ count: 0, totalPages: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const phasesScrollRef = useRef(null);
  const { challengeId } = useParams();
  const fetchChallengeData = async () => {
    setLoading(true); setError("");
    try {
      let response = await fetch(
        buildPaginatedUrl(`${API_BASE_URL}/api/v0/challenges/admin/${challengeId}/phases/`, page),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          buildPaginatedUrl(`${API_BASE_URL}/api/v0/challenges/admin/${challengeId}/phases/`, page),
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Categories Data:", data);
      const parsed = paginationFromResponse(data, page);
      if (parsed.totalPages > 0 && page > parsed.totalPages) {
        setPage(1);
        return;
      }
      setChallenge(data.challenge || null);
      setPhases((current) =>
        page === 1 ? parsed.results : [...current, ...parsed.results],
      );
      setPagination(parsed);
    } catch (error) {
      console.error("Error fetching categories data:", error);
      setError("خطا در دریافت اطلاعات چالش");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchChallengeData();
  }, [challengeId, page]);
  return (
    <LayoutPage
      activeIndex={4}
      navItems={["مدیریت چالش‌ها", `چالش ${challengeId}`]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto"
    >
      <AsyncContent loading={loading && page === 1} error={error} empty={!challenge} onRetry={fetchChallengeData}>
      <><Buttons data={challenge} onChallengeChange={(updates) => setChallenge((current) => ({ ...current, leverage_mode: updates.mode, fixed_leverage: updates.fixed_leverage, allowed_leverages: updates.options }))} />
      <ChallengeInfoContainer data={challenge} />
      <div className="w-full">
        <div ref={phasesScrollRef} className="w-full overflow-x-auto inline-flex gap-5 whitespace-nowrap align-top">
          {phases.map((phase, index) => (
              <PhaseInfoContainer
                key={index}
                header={`اطلاعات فاز ${
                  phase.phase_type === "phase1"
                    ? "۱"
                    : phase.phase_type === "phase2"
                      ? "۲"
                      : "قابل برداشت"
                }`}
                headSVG="info"
                phaseData={phase}
                onPhaseChange={(updated) => setPhases((current) => current.map((item) => item.id === updated.id ? updated : item))}
              />
            ))}
        </div>
        <Pagination page={page} totalPages={pagination.totalPages} count={pagination.count} loading={loading} onPageChange={setPage} scrollRootRef={phasesScrollRef} axis="horizontal" />
      </div>
      </>
      </AsyncContent>
    </LayoutPage>
  );
}
